import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getproductcategory } from '../../utilities/api';

export const fetchProductcategory = createAsyncThunk('modulegroup/fetch', async ({ rolename, clientname, branch_id }, { rejectWithValue }) => {
    try {
        const data = await getproductcategory({ rolename, clientname, branch_id: branch_id || '' });
        return data;
    } catch (error) {
        return rejectWithValue(error.message || 'Failed to fetch product categories');
    }
});

const initialState = {
    clients: [],
    branches: [],
    categoryData: [],
    selectedClient: null,
    selectedBranch: null,
    loading: true,
    error: null
};

const productcategorySlice = createSlice({
    name: 'productCategory',
    initialState,
    reducers: {
        setSelectedClient: (state, action) => {
            state.selectedClient = action.payload;
            state.selectedBranch = null;
        },
        setSelectedBranch: (state, action) => {
            state.selectedBranch = action.payload;
        },
        resetFilters: (state) => {
            state.selectedClient = null;
            state.selectedBranch = null;
            state.error = null;
        },
        clearError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductcategory.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProductcategory.fulfilled, (state, action) => {
                state.loading = false;
                const raw = action.payload || {};
                const d = raw.data || raw;
                const clients = Array.isArray(d.clients) ? d.clients : [];
                const branches = Array.isArray(d.branches) ? d.branches : [];
                state.clients = clients;
                state.branches = branches;
                const rows = d.product_category || d.product_categories || [];
                state.categoryData = Array.isArray(rows)
                    ? rows.map((item) => {
                          const rawStatus = item.prcat_status || item.status || 'Active';
                          const normalizedStatus = (() => {
                              const s = String(rawStatus).toLowerCase();
                              if (s === '1' || s === 'active') return 'Active';
                              if (s === '0' || s === 'inactive') return 'Inactive';
                              return rawStatus;
                          })();
                          const clientObj = clients.find((c) => String(c.client_id) === String(item.client_id));
                          const branchObj = branches.find((b) => String(b.branch_id) === String(item.branch_id));
                          return {
                              ...item,
                              category_name: item.prcat_cat_name || item.category_name || '',
                              client_id: item.client_id || '',
                              client_name: item.client_name || clientObj?.client_name || '',
                              branch_name: item.branch_name || branchObj?.branch_name || '',
                              status: normalizedStatus
                          };
                      })
                    : [];
            })
            .addCase(fetchProductcategory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.categoryData = [];
            });
    }
});

export const { setSelectedClient, setSelectedBranch, resetFilters, clearError } = productcategorySlice.actions;

export const selectCategoryData = (state) => state.productCategory.categoryData;
export const selectClients = (state) => state.productCategory.clients;
export const selectBranches = (state) => state.productCategory.branches;
export const selectLoading = (state) => state.productCategory.loading;
export const selectSelectedClient = (state) => state.productCategory.selectedClient;
export const selectSelectedBranch = (state) => state.productCategory.selectedBranch;
export const selectError = (state) => state.productCategory.error;

export default productcategorySlice.reducer;
